var React = require('react');

function Siguiente (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H1200V800H0z","transform":"translate(-914 -551)","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M955.932 575.5l-8.672-4.878-.872-.49.98-1.744.872.49 12 6.75 1.55.872-1.55.872-12 6.75-.871.49-.98-1.743.87-.49 8.673-4.879H918v-2h37.932z","transform":"translate(-914 -551)","key":1})]));
}

Siguiente.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Siguiente;

Siguiente.default = Siguiente;
